import React, { useState, useEffect } from "react"
import Cookies from "js-cookie"
import { useTranslation } from "@zestia/gatsby-plugin-react-i18next"

const LogInButton = ({ className = "" }) => {
  const { t } = useTranslation()

  const [url, setUrl] = useState("https://app.capsulecrm.com/siteaddress/goto")

  useEffect(() => {
    const lastAccountUsed = Cookies.get("last_account_used")

    if (lastAccountUsed) {
      setUrl(lastAccountUsed)
    }
  }, [])

  return (
    <a className={`${className}`} href={url}>
      {t("navigation.login")}
    </a>
  )
}

export default LogInButton
